var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: ['t-input-action']
  }, [_c('div', {
    class: ['t-input-text']
  }, [_c('input', _vm._b({
    ref: "input",
    attrs: {
      "type": _vm.type,
      "min": _vm.min,
      "max": _vm.max,
      "autocapitalize": "off"
    },
    domProps: {
      "value": _vm.model
    },
    on: {
      "input": _vm.handleInput
    }
  }, 'input', _vm.$attrs, false)), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.model.length,
      expression: "model.length"
    }],
    staticClass: "t-input-clear",
    attrs: {
      "aria-label": "Clear Text Input",
      "type": "button"
    },
    on: {
      "click": function click($event) {
        _vm.$emit('reset');

        _vm.focus();
      }
    }
  }, [_c('span', {
    staticClass: "icon-close"
  })])]), _c('div', {
    class: [_vm.baseClass, _vm.btnClass]
  }, [_vm.btn ? _c('button', {
    class: ['t-button', {
      't-disabled': _vm.disabled || !_vm.valid
    }],
    attrs: {
      "type": "submit",
      "disabled": _vm.disabled || !_vm.valid
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.btnLabel) + " ")])]) : _vm._e()])]);
}
var staticRenderFns = []

export { render, staticRenderFns }